import { log } from 'utils/logging';

import { RichError } from './RichError';

export function trackError(message: string | Error) {
  let metadata = {};

  if (message instanceof RichError) {
    metadata = message.metadata;
  }

  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  if (window.trackJs && window.trackJs.track) {
    Object.keys(metadata).forEach((key) => {
      // @ts-expect-error TS(2339): Property 'trackJs' does not exist on type 'Window ... Remove this comment to see the full error message
      window.trackJs.addMetadata(key, metadata[key]);
    });
    window.trackJs.track(message);
    Object.keys(metadata).forEach((key) => {
      window.trackJs.removeMetadata(key);
    });
  } else {
    log.error(message, metadata);
  }
}
